function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from "react";
import { useQuery, useLazyQuery } from "@apollo/client";
import "./TaskOverview.css";
import { MdDateRange, MdAssignmentInd, MdError, MdFormatListBulleted } from "react-icons/md";
import { FilterContext, UserContext, AccordionContext } from "../index";
import Table from "react-bootstrap/Table";
import { Chart } from "react-google-charts";
import Loader from "./../Loader/Loader";
import moment from "moment-timezone";
import Button from "react-bootstrap/Button";
import classNames from "classnames";
import { TASK_OVERVIEW_SUMMARY_DATA_QUERY, TASK_OVERVIEW_MY_TASK_QUERY, TASK_OVERVIEW_CHART_QUERY, TASK_OVERVIEW_ACTIVITY_SUMMARY_DATA_QUERY, TASK_OVERVIEW_PROJECT_LISTING_DATA_QUERY } from "./query";
import { FiMaximize } from "react-icons/fi";
import Modal from "react-bootstrap/Modal";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import Select from "react-select";
import { USER_LISTING_QUERY } from "./../ManualPages/query";
import { ProjectEnableSection } from "./../MyProjects/MyProjects";
var LIMIT = 20;
var offsets = 0;
var TaskOverview = function TaskOverview(props) {
  var _React$useContext = React.useContext(FilterContext),
    teamId = _React$useContext.teamId,
    organisationId = _React$useContext.organisationId,
    startDate = _React$useContext.startDate,
    endDate = _React$useContext.endDate,
    organisationSettings = _React$useContext.organisationSettings,
    organisationUserCount = _React$useContext.organisationUserCount,
    organisationBilling = _React$useContext.organisationBilling,
    role = _React$useContext.role,
    from = _React$useContext.from,
    organisationStatus = _React$useContext.organisationStatus;

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  var _React$useContext2 = React.useContext(UserContext),
    user = _React$useContext2.user;
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    taskOverviewDataFetch = _React$useState2[0],
    setTaskOverviewDataFetch = _React$useState2[1];
  var _React$useState3 = React.useState(true),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    taskOverviewActivityDataFetch = _React$useState4[0],
    setTaskOverviewActivityDataFetch = _React$useState4[1];
  //const [taskOverviewChartFetch, setTaskOverviewChartFetch] = React.useState(true);
  //load more
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isAllLoaded = _React$useState6[0],
    setIsAllLoaded = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    isLoadingMore = _React$useState8[0],
    setIsLoadingMore = _React$useState8[1];
  var _React$useState9 = React.useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    isLoadMoreButton = _React$useState10[0],
    setIsLoadMoreButton = _React$useState10[1];
  var _React$useState11 = React.useState(null),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    showTaskModal = _React$useState12[0],
    setShowTaskModal = _React$useState12[1];
  var _React$useState13 = React.useState({
      label: "All Tasks",
      value: ""
    }),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    statusCheck = _React$useState14[0],
    setStatusCheck = _React$useState14[1];
  var _React$useState15 = React.useState({
      label: "All Project",
      value: ""
    }),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    projectCheck = _React$useState16[0],
    setProjectCheck = _React$useState16[1];
  var _React$useState17 = React.useState({
      label: "All Member",
      value: ""
    }),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    userCheck = _React$useState18[0],
    setUserCheck = _React$useState18[1];
  var _React$useState19 = React.useState({
      label: "Today",
      value: "today"
    }),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    dateCheck = _React$useState20[0],
    setDateCheck = _React$useState20[1];
  var _React$useState21 = React.useState(true),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    isTaskViewCheck = _React$useState22[0],
    setTaskViewCheck = _React$useState22[1];
  var _React$useState23 = React.useState(true),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    planCheck = _React$useState24[0],
    setPlanCheck = _React$useState24[1];
  var teamViewRef = React.useRef(null);
  var myViewRef = React.useRef(null);
  var highlightRef = React.useRef(null);
  // const [planType, setPlanType] = React.useState("monthly");

  React.useEffect(function () {
    if ((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planId) == null || (organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped" || organisationStatus == "inactive") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  React.useEffect(function () {
    if (role === "Member" && !organisationSettings.projectManagementFeature) {
      props === null || props === void 0 ? void 0 : props.history.push("/my-work");
    }
  }, [role]);
  var _useQuery = useQuery(TASK_OVERVIEW_SUMMARY_DATA_QUERY, {
      variables: {
        organisationId: organisationId,
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        userId: user.userId,
        role: role,
        viewType: role != "Member" && isTaskViewCheck ? "teamView" : "myView"
      },
      skip: !user.userId || !organisationId
    }),
    taskSummaryData = _useQuery.data,
    taskSummaryError = _useQuery.error,
    taskSummaryLoading = _useQuery.loading,
    refetch = _useQuery.refetch;
  var _useQuery2 = useQuery(TASK_OVERVIEW_PROJECT_LISTING_DATA_QUERY, {
      variables: {
        organisationId: organisationId,
        userId: user.userId,
        role: role,
        viewType: role != "Member" && isTaskViewCheck ? "teamView" : "myView"
      },
      skip: !user.userId || !organisationId
    }),
    projectListData = _useQuery2.data,
    projectListError = _useQuery2.error,
    projectListLoading = _useQuery2.loading,
    projectListRefetch = _useQuery2.refetch;
  var _useLazyQuery = useLazyQuery(TASK_OVERVIEW_ACTIVITY_SUMMARY_DATA_QUERY, {
      variables: {
        organisationId: organisationId,
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        userId: user.userId,
        dateCheck: dateCheck && dateCheck.value !== "" ? dateCheck.value : null,
        role: role,
        viewType: role != "Member" && isTaskViewCheck ? "teamView" : "myView"
      },
      fetchPolicy: "network-only",
      skip: !user.userId && !organisationId
    }),
    _useLazyQuery2 = _slicedToArray(_useLazyQuery, 2),
    getTaskOverviewActivitySummary = _useLazyQuery2[0],
    _useLazyQuery2$ = _useLazyQuery2[1],
    taskOverviewActivityData = _useLazyQuery2$.data,
    taskOverviewActivityError = _useLazyQuery2$.error,
    taskOverviewActivityLoading = _useLazyQuery2$.loading;
  var _useLazyQuery3 = useLazyQuery(TASK_OVERVIEW_MY_TASK_QUERY, {
      variables: {
        organisationId: organisationId,
        timeZone: organisationSettings === null || organisationSettings === void 0 ? void 0 : organisationSettings.organisationTimezone,
        userId: role != "Member" && role != "Head" && isTaskViewCheck ? userCheck && userCheck.value !== "" ? userCheck.value : null : user.userId,
        limit: LIMIT,
        offset: 0,
        status: statusCheck && statusCheck.value !== "" ? statusCheck.value : null,
        projectId: projectCheck && projectCheck.value !== "" ? projectCheck.value : null,
        role: role,
        viewType: role != "Member" && isTaskViewCheck ? "teamView" : "myView"
      },
      fetchPolicy: "network-only",
      skip: !user.userId && !organisationId
    }),
    _useLazyQuery4 = _slicedToArray(_useLazyQuery3, 2),
    getTaskOverviewDetails = _useLazyQuery4[0],
    _useLazyQuery4$ = _useLazyQuery4[1],
    taskOverviewMyTaskDetailsData = _useLazyQuery4$.data,
    taskOverviewMyTaskDetailsError = _useLazyQuery4$.error,
    taskOverviewMyTaskDetailsLoading = _useLazyQuery4$.loading,
    fetchMore = _useLazyQuery4$.fetchMore;
  var _useQuery3 = useQuery(USER_LISTING_QUERY, {
      variables: {
        organisationId: organisationId,
        teamId: "all",
        role: role
      },
      skip: !organisationId
    }),
    userListData = _useQuery3.data,
    userListError = _useQuery3.error,
    userListLoading = _useQuery3.loading;

  // const [
  //   getTaskOverviewChart,
  //   { data: taskOverviewMyTaskChartData, error: taskOverviewMyTaskChartError, loading: taskOverviewMyTaskChartLoading },
  // ] = useLazyQuery(TASK_OVERVIEW_CHART_QUERY, {
  //   variables: {
  //     organisationId,
  //     timeZone: organisationSettings?.organisationTimezone,
  //     userId: user.userId,
  //   },
  //   fetchPolicy: "network-only",
  //   skip: !user.userId && !organisationId,
  // });

  React.useEffect(function () {
    if (taskSummaryLoading || taskSummaryError) return;
    if (!taskSummaryData) return;
    if (!taskSummaryLoading && taskSummaryData !== null && taskSummaryData !== void 0 && taskSummaryData.getTaskOvewviewSummary && taskOverviewActivityDataFetch) {
      getTaskOverviewActivitySummary();
    }
  }, [taskSummaryData === null || taskSummaryData === void 0 ? void 0 : taskSummaryData.getTaskOvewviewSummary]);
  React.useEffect(function () {
    if (taskOverviewActivityLoading || taskOverviewActivityError) return;
    if (!taskOverviewActivityData) return;
    if (!taskOverviewActivityLoading && taskOverviewActivityData !== null && taskOverviewActivityData !== void 0 && taskOverviewActivityData.getTaskOvewviewActivitySummary && taskOverviewDataFetch) {
      getTaskOverviewDetails();
    }
  }, [taskOverviewActivityData === null || taskOverviewActivityData === void 0 ? void 0 : taskOverviewActivityData.getTaskOvewviewActivitySummary]);
  React.useEffect(function () {
    refetch === null || refetch === void 0 ? void 0 : refetch();
    projectListRefetch === null || projectListRefetch === void 0 ? void 0 : projectListRefetch();
    setTaskOverviewDataFetch(true);
    setTaskOverviewActivityDataFetch(true);
  }, [props.location.key]);
  React.useEffect(function () {
    setIsAllLoaded(false);
  }, [statusCheck, projectCheck, userCheck]);
  var handleLoadMore = function handleLoadMore() {
    if (taskOverviewMyTaskDetailsLoading) return;
    setIsLoadingMore(true);
    offsets = offsets + 1;
    fetchMore({
      variables: {
        offset: offsets * LIMIT
      },
      updateQuery: function updateQuery(prev, _ref) {
        var _fetchMoreResult$getT, _fetchMoreResult$getT2, _fetchMoreResult$getT3;
        var fetchMoreResult = _ref.fetchMoreResult;
        if (!fetchMoreResult) return prev;
        if ((fetchMoreResult === null || fetchMoreResult === void 0 ? void 0 : (_fetchMoreResult$getT = fetchMoreResult.getTaskOvewviewMyTaskCard) === null || _fetchMoreResult$getT === void 0 ? void 0 : _fetchMoreResult$getT.length) === 0 && ((_fetchMoreResult$getT2 = fetchMoreResult.getTaskOvewviewMyTaskCard) === null || _fetchMoreResult$getT2 === void 0 ? void 0 : _fetchMoreResult$getT2.length) < LIMIT && !isAllLoaded) {
          setIsAllLoaded(true);
        }
        setIsLoadingMore(false);
        var NewFilterData = [];
        (_fetchMoreResult$getT3 = fetchMoreResult.getTaskOvewviewMyTaskCard) === null || _fetchMoreResult$getT3 === void 0 ? void 0 : _fetchMoreResult$getT3.forEach(function (newTask) {
          var found = prev.getTaskOvewviewMyTaskCard.find(function (item) {
            return item.taskId === newTask.taskId;
          });
          if (!found) {
            // If not found, add validation.
            NewFilterData.push(newTask);
          }
        });
        return _objectSpread(_objectSpread({}, prev), {}, {
          getTaskOvewviewMyTaskCard: [].concat(_toConsumableArray(prev.getTaskOvewviewMyTaskCard), NewFilterData)
        });
      }
    });
  };
  var handleKey = function handleKey(data) {
    if (data == "my-view") {
      setTaskViewCheck(function (prev) {
        return prev === true ? false : true;
      });
    } else if (data == "team-view") {
      setTaskViewCheck(function (prev) {
        return prev === true ? false : true;
      });
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "task-overview-root"
  }, !organisationSettings.projectManagementFeature ? /*#__PURE__*/React.createElement(ProjectEnableSection, {
    user: user,
    organisationId: organisationId,
    organisationSettings: organisationSettings,
    filterId: null,
    role: role,
    pageName: "task-overview",
    isTaskViewCheck: isTaskViewCheck,
    teamId: null,
    projectIds: null,
    taskIds: null,
    planName: null,
    last14Days: null,
    from: null,
    propsUserId: null,
    userIds: null,
    userActive: null,
    projectActive: null,
    taskActive: null,
    startDate: null,
    endDate: null,
    projectId: null,
    userUrl: null
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, role != "Member" ? /*#__PURE__*/React.createElement("div", {
    className: "task-overview-team-my-view-toggle-div"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-overview-team-my-view-toggle-type"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    "class": "task-overview-pill-button-input",
    checked: isTaskViewCheck,
    onChange: function onChange(e) {
      return setTaskViewCheck(function (prevValue) {
        return !prevValue;
      });
    }
  }), /*#__PURE__*/React.createElement("span", {
    "class": "task-overview-pill-button"
  }, /*#__PURE__*/React.createElement("span", {
    ref: teamViewRef,
    "class": "task-overview-pill-button-selection pill-button-selection_on ".concat(isTaskViewCheck == true ? "task-overview-pill-button-selection_active" : ""),
    onClick: function onClick(e) {
      // setPlanType("monthly");
      setTaskViewCheck(true);
    }
  }, "Team View"), /*#__PURE__*/React.createElement("span", {
    ref: myViewRef,
    "class": "task-overview-pill-button-selection pill-button-selection_off ".concat(isTaskViewCheck == false ? "task-overview-pill-button-selection_active" : ""),
    onClick: function onClick(e) {
      // setPlanType("annually");

      setTaskViewCheck(false);
    }
  }, "My View"), /*#__PURE__*/React.createElement("span", {
    "class": "task-overview-pill-button-highlight",
    style: isTaskViewCheck ? {
      width: teamViewRef.current ? teamViewRef.current.offsetWidth : null,
      left: teamViewRef.current ? teamViewRef.current.offsetLeft : null
    } : {
      width: myViewRef.current ? myViewRef.current.offsetWidth : null,
      left: myViewRef.current ? myViewRef.current.offsetLeft : null
    },
    ref: highlightRef
  })))) : null, /*#__PURE__*/React.createElement(TaskOverviewDetails, {
    taskSummaryData: taskSummaryData,
    taskSummaryError: taskSummaryError,
    taskSummaryLoading: taskSummaryLoading,
    taskOverviewActivityData: taskOverviewActivityData,
    taskOverviewActivityError: taskOverviewActivityError,
    taskOverviewActivityLoading: taskOverviewActivityLoading,
    setTaskOverviewActivityDataFetch: setTaskOverviewActivityDataFetch,
    dateCheck: dateCheck,
    setDateCheck: setDateCheck,
    taskOverviewMyTaskDetailsData: taskOverviewMyTaskDetailsData,
    taskOverviewMyTaskDetailsError: taskOverviewMyTaskDetailsError,
    taskOverviewMyTaskDetailsLoading: taskOverviewMyTaskDetailsLoading,
    setTaskOverviewDataFetch: setTaskOverviewDataFetch,
    isAllLoaded: isAllLoaded,
    setIsAllLoaded: setIsAllLoaded,
    isLoadingMore: isLoadingMore,
    setIsLoadingMore: setIsLoadingMore,
    isLoadMoreButton: isLoadMoreButton,
    setIsLoadMoreButton: setIsLoadMoreButton,
    handleLoadMore: handleLoadMore,
    showTaskModal: showTaskModal,
    setShowTaskModal: setShowTaskModal,
    statusCheck: statusCheck,
    setStatusCheck: setStatusCheck,
    projectCheck: projectCheck,
    setProjectCheck: setProjectCheck,
    projectListData: projectListData,
    projectListError: projectListError,
    projectListLoading: projectListLoading,
    viewType: isTaskViewCheck ? "teamView" : "myView",
    role: role,
    userListData: userListData,
    userListError: userListError,
    userListLoading: userListLoading,
    userCheck: userCheck,
    setUserCheck: setUserCheck
  })));
};
var TaskOverviewDetails = function TaskOverviewDetails(props) {
  var taskSummaryData = props.taskSummaryData,
    taskSummaryError = props.taskSummaryError,
    taskSummaryLoading = props.taskSummaryLoading,
    taskOverviewActivityData = props.taskOverviewActivityData,
    taskOverviewActivityError = props.taskOverviewActivityError,
    taskOverviewActivityLoading = props.taskOverviewActivityLoading,
    setTaskOverviewActivityDataFetch = props.setTaskOverviewActivityDataFetch,
    dateCheck = props.dateCheck,
    setDateCheck = props.setDateCheck,
    taskOverviewMyTaskDetailsData = props.taskOverviewMyTaskDetailsData,
    taskOverviewMyTaskDetailsError = props.taskOverviewMyTaskDetailsError,
    taskOverviewMyTaskDetailsLoading = props.taskOverviewMyTaskDetailsLoading,
    setTaskOverviewDataFetch = props.setTaskOverviewDataFetch,
    isAllLoaded = props.isAllLoaded,
    setIsAllLoaded = props.setIsAllLoaded,
    isLoadingMore = props.isLoadingMore,
    setIsLoadingMore = props.setIsLoadingMore,
    isLoadMoreButton = props.isLoadMoreButton,
    setIsLoadMoreButton = props.setIsLoadMoreButton,
    handleLoadMore = props.handleLoadMore,
    showTaskModal = props.showTaskModal,
    setShowTaskModal = props.setShowTaskModal,
    statusCheck = props.statusCheck,
    setStatusCheck = props.setStatusCheck,
    projectCheck = props.projectCheck,
    setProjectCheck = props.setProjectCheck,
    projectListData = props.projectListData,
    projectListError = props.projectListError,
    projectListLoading = props.projectListLoading,
    viewType = props.viewType,
    role = props.role,
    userListData = props.userListData,
    userListError = props.userListError,
    userListLoading = props.userListLoading,
    userCheck = props.userCheck,
    setUserCheck = props.setUserCheck;
  return /*#__PURE__*/React.createElement(React.Fragment, null, " ", /*#__PURE__*/React.createElement(SummaryCard, {
    taskSummaryData: taskSummaryData,
    taskSummaryError: taskSummaryError,
    taskSummaryLoading: taskSummaryLoading,
    taskOverviewActivityData: taskOverviewActivityData,
    taskOverviewActivityError: taskOverviewActivityError,
    taskOverviewActivityLoading: taskOverviewActivityLoading,
    setTaskOverviewActivityDataFetch: setTaskOverviewActivityDataFetch,
    dateCheck: dateCheck,
    setDateCheck: setDateCheck,
    viewType: viewType,
    role: role
  }), /*#__PURE__*/React.createElement(TaskList, {
    taskOverviewMyTaskDetailsData: taskOverviewMyTaskDetailsData,
    taskOverviewMyTaskDetailsError: taskOverviewMyTaskDetailsError,
    taskOverviewMyTaskDetailsLoading: taskOverviewMyTaskDetailsLoading,
    setTaskOverviewDataFetch: setTaskOverviewDataFetch,
    isAllLoaded: isAllLoaded,
    setIsAllLoaded: setIsAllLoaded,
    isLoadingMore: isLoadingMore,
    setIsLoadingMore: setIsLoadingMore,
    isLoadMoreButton: isLoadMoreButton,
    setIsLoadMoreButton: setIsLoadMoreButton,
    handleLoadMore: handleLoadMore,
    showTaskModal: showTaskModal,
    setShowTaskModal: setShowTaskModal,
    statusCheck: statusCheck,
    setStatusCheck: setStatusCheck,
    projectCheck: projectCheck,
    setProjectCheck: setProjectCheck,
    projectListData: projectListData,
    projectListError: projectListError,
    projectListLoading: projectListLoading,
    viewType: viewType,
    role: role,
    userListData: userListData,
    userListError: userListError,
    userListLoading: userListLoading,
    userCheck: userCheck,
    setUserCheck: setUserCheck
  }));
};
var SummaryCard = function SummaryCard(props) {
  var _taskSummaryData$getT, _taskSummaryData$getT2, _taskSummaryData$getT3, _taskSummaryData$getT4, _taskSummaryData$getT5, _taskSummaryData$getT6;
  var taskSummaryData = props.taskSummaryData,
    taskSummaryLoading = props.taskSummaryLoading,
    taskSummaryError = props.taskSummaryError,
    taskOverviewActivityData = props.taskOverviewActivityData,
    taskOverviewActivityError = props.taskOverviewActivityError,
    taskOverviewActivityLoading = props.taskOverviewActivityLoading,
    setTaskOverviewActivityDataFetch = props.setTaskOverviewActivityDataFetch,
    dateCheck = props.dateCheck,
    setDateCheck = props.setDateCheck,
    viewType = props.viewType,
    role = props.role;

  // totalProject
  // totalTask

  var dateOptionList = [{
    label: "Today",
    value: "today"
  }, {
    label: "Yesterday",
    value: "yesterday"
  }, {
    label: "Last 7 Days",
    value: "last-7-Days"
  }, {
    label: "This Month",
    value: "this-month"
  }];

  // error: taskSummaryError, loading: taskSummaryLoading, error: taskOverviewActivityError, loading:
  // taskOverviewActivityLoading error: taskOverviewMyTaskDetailsError, loading: taskOverviewMyTaskDetailsLoading,

  // <Loader />
  //     ) : taskSummaryError ? (
  //       <div className="common-err-refresh-text">Something went wrong, please refresh the page.</div>

  return /*#__PURE__*/React.createElement("div", {
    className: "task-overview-grid"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-overview-grid-over-all-summary-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-overview-grid-over-all-summary-card-head"
  }, /*#__PURE__*/React.createElement("span", {
    className: "task-overview-grid-over-all-summary-card-head-span"
  }, "Overall Summary")), taskSummaryLoading ? /*#__PURE__*/React.createElement(Loader, null) : taskSummaryError ? /*#__PURE__*/React.createElement("div", {
    className: "common-err-refresh-text"
  }, "Something went wrong, please refresh the page.") : /*#__PURE__*/React.createElement("div", {
    className: "task-overview-grid-over-all-summary-card-content"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "task-overview-grid-over-all-summary-card-content-small-card task-overview-grid-small-card-task-assigned-me"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
    "class": "font-weight-bold "
  }, viewType == "myView" || role == "Member" ? taskSummaryData === null || taskSummaryData === void 0 ? void 0 : (_taskSummaryData$getT = taskSummaryData.getTaskOvewviewSummary) === null || _taskSummaryData$getT === void 0 ? void 0 : _taskSummaryData$getT.taskAssignedToMe : taskSummaryData === null || taskSummaryData === void 0 ? void 0 : (_taskSummaryData$getT2 = taskSummaryData.getTaskOvewviewSummary) === null || _taskSummaryData$getT2 === void 0 ? void 0 : _taskSummaryData$getT2.totalTask), /*#__PURE__*/React.createElement("div", {
    "class": "task-overview-grid-over-all-summary-card-content-small-card-title "
  }, viewType == "myView" || role == "Member" ? "Task assigned to me" : "Total Task")), /*#__PURE__*/React.createElement("div", {
    className: "task-overview-grid-small-card-icon"
  }, /*#__PURE__*/React.createElement(MdFormatListBulleted, null))), /*#__PURE__*/React.createElement("div", {
    "class": "task-overview-grid-over-all-summary-card-content-small-card task-overview-grid-small-card-project-assigned-me"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
    "class": " font-weight-bold "
  }, viewType == "myView" || role == "Member" ? taskSummaryData === null || taskSummaryData === void 0 ? void 0 : (_taskSummaryData$getT3 = taskSummaryData.getTaskOvewviewSummary) === null || _taskSummaryData$getT3 === void 0 ? void 0 : _taskSummaryData$getT3.projectAssignedToMe : taskSummaryData === null || taskSummaryData === void 0 ? void 0 : (_taskSummaryData$getT4 = taskSummaryData.getTaskOvewviewSummary) === null || _taskSummaryData$getT4 === void 0 ? void 0 : _taskSummaryData$getT4.totalProject), /*#__PURE__*/React.createElement("div", {
    "class": "task-overview-grid-over-all-summary-card-content-small-card-title "
  }, viewType == "myView" || role == "Member" ? "Project assigned to me" : "Total Project")), /*#__PURE__*/React.createElement("div", {
    className: "task-overview-grid-small-card-icon"
  }, /*#__PURE__*/React.createElement(MdAssignmentInd, null))), /*#__PURE__*/React.createElement("div", {
    "class": "task-overview-grid-over-all-summary-card-content-small-card task-overview-grid-small-card-due-today"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
    "class": " font-weight-bold "
  }, taskSummaryData === null || taskSummaryData === void 0 ? void 0 : (_taskSummaryData$getT5 = taskSummaryData.getTaskOvewviewSummary) === null || _taskSummaryData$getT5 === void 0 ? void 0 : _taskSummaryData$getT5.todayOnDueCount), /*#__PURE__*/React.createElement("div", {
    "class": "task-overview-grid-over-all-summary-card-content-small-card-title "
  }, "Due today")), /*#__PURE__*/React.createElement("div", {
    className: "task-overview-grid-small-card-icon"
  }, /*#__PURE__*/React.createElement(MdDateRange, null))), /*#__PURE__*/React.createElement("div", {
    "class": "task-overview-grid-over-all-summary-card-content-small-card task-overview-grid-small-card-due-past"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", {
    "class": "font-weight-bold "
  }, taskSummaryData === null || taskSummaryData === void 0 ? void 0 : (_taskSummaryData$getT6 = taskSummaryData.getTaskOvewviewSummary) === null || _taskSummaryData$getT6 === void 0 ? void 0 : _taskSummaryData$getT6.onDueTaskCount), /*#__PURE__*/React.createElement("div", {
    "class": "task-overview-grid-over-all-summary-card-content-small-card-title "
  }, "Past due task")), /*#__PURE__*/React.createElement("div", {
    className: "task-overview-grid-small-card-icon"
  }, /*#__PURE__*/React.createElement(MdError, null))))), /*#__PURE__*/React.createElement("div", {
    className: "task-overview-grid-today-summary-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-overview-grid-over-all-summary-card-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-overview-grid-over-all-summary-card-head-span"
  }, "Activity Summary"), /*#__PURE__*/React.createElement("div", {
    className: "task-overview-my-task-filter-user-activity"
  }, /*#__PURE__*/React.createElement(Select, {
    value: dateCheck,
    onChange: function onChange(e) {
      return setDateCheck(e);
    },
    options: dateOptionList,
    className: "task-overview-my-task-user-select"
    //styles={customStyles}
    ,
    classNamePrefix: "Filter By User"
    //isMulti
  }))), /*#__PURE__*/React.createElement("div", {
    className: "task-overview-grid-over-all-summary-card-content-row"
  }, /*#__PURE__*/React.createElement(ActivitySummary, {
    taskOverviewActivityData: taskOverviewActivityData,
    taskOverviewActivityError: taskOverviewActivityError,
    taskOverviewActivityLoading: taskOverviewActivityLoading,
    setTaskOverviewActivityDataFetch: setTaskOverviewActivityDataFetch,
    taskSummaryData: taskSummaryData,
    dateCheck: dateCheck
  }))));
};
var ActivitySummary = function ActivitySummary(props) {
  var _taskOverviewActivity, _taskOverviewActivity2, _taskOverviewActivity3, _taskOverviewActivity4;
  var taskOverviewActivityData = props.taskOverviewActivityData,
    taskOverviewActivityError = props.taskOverviewActivityError,
    taskOverviewActivityLoading = props.taskOverviewActivityLoading,
    setTaskOverviewActivityDataFetch = props.setTaskOverviewActivityDataFetch,
    dateCheck = props.dateCheck;
  if (taskOverviewActivityLoading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "task-overview-grid-today-summary-card-content-top-loader"
    }, /*#__PURE__*/React.createElement(Loader, null));
  }
  if (taskOverviewActivityError) {
    return /*#__PURE__*/React.createElement("div", null, "Something went wrong, pls refresh the page");
  }
  if (!taskOverviewActivityData) {
    return null;
  }
  setTaskOverviewActivityDataFetch(false);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "task-overview-grid-over-all-summary-card-content-combine task-overview-grid-small-card-task-assigned-me"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-overview-grid-today-summary-card-content-top"
  }, /*#__PURE__*/React.createElement("h4", {
    "class": " font-weight-bold "
  }, taskOverviewActivityData === null || taskOverviewActivityData === void 0 ? void 0 : (_taskOverviewActivity = taskOverviewActivityData.getTaskOvewviewActivitySummary) === null || _taskOverviewActivity === void 0 ? void 0 : _taskOverviewActivity.todayWorkedCount, " Task"), /*#__PURE__*/React.createElement("div", {
    "class": "task-overview-grid-over-all-summary-card-content-small-card-title "
  }, dateCheck && dateCheck.label ? dateCheck.label : "", " worked task")), /*#__PURE__*/React.createElement("div", {
    className: "task-overview-grid-today-summary-card-content task-overview-grid-today-summary-card-content-color"
  }, /*#__PURE__*/React.createElement("h4", {
    "class": " font-weight-bold "
  }, taskOverviewActivityData === null || taskOverviewActivityData === void 0 ? void 0 : (_taskOverviewActivity2 = taskOverviewActivityData.getTaskOvewviewActivitySummary) === null || _taskOverviewActivity2 === void 0 ? void 0 : _taskOverviewActivity2.totalWorkedCount, " Task"), /*#__PURE__*/React.createElement("div", {
    "class": "task-overview-grid-over-all-summary-card-content-small-card-title "
  }, "Total worked task"))), /*#__PURE__*/React.createElement("div", {
    className: "task-overview-grid-over-all-summary-card-content-combine task-overview-grid-small-card-project-assigned-me"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-overview-grid-today-summary-card-content-top"
  }, /*#__PURE__*/React.createElement("h4", {
    "class": " font-weight-bold "
  }, taskOverviewActivityData === null || taskOverviewActivityData === void 0 ? void 0 : (_taskOverviewActivity3 = taskOverviewActivityData.getTaskOvewviewActivitySummary) === null || _taskOverviewActivity3 === void 0 ? void 0 : _taskOverviewActivity3.todayWorkedHours), /*#__PURE__*/React.createElement("div", {
    "class": "task-overview-grid-over-all-summary-card-content-small-card-title "
  }, dateCheck && dateCheck.label ? dateCheck.label : "", " worked time on task", " ")), /*#__PURE__*/React.createElement("div", {
    className: "task-overview-grid-today-summary-card-content task-overview-grid-today-summary-card-content-color"
  }, /*#__PURE__*/React.createElement("h4", {
    "class": " font-weight-bold "
  }, taskOverviewActivityData === null || taskOverviewActivityData === void 0 ? void 0 : (_taskOverviewActivity4 = taskOverviewActivityData.getTaskOvewviewActivitySummary) === null || _taskOverviewActivity4 === void 0 ? void 0 : _taskOverviewActivity4.totalWorkedHours), /*#__PURE__*/React.createElement("div", {
    "class": "task-overview-grid-over-all-summary-card-content-small-card-title "
  }, "Total worked time on task", " "))));
};
var TaskList = function TaskList(props) {
  var _projectListData$getT, _userListData$getProj;
  var taskOverviewMyTaskDetailsData = props.taskOverviewMyTaskDetailsData,
    taskOverviewMyTaskDetailsError = props.taskOverviewMyTaskDetailsError,
    taskOverviewMyTaskDetailsLoading = props.taskOverviewMyTaskDetailsLoading,
    setTaskOverviewDataFetch = props.setTaskOverviewDataFetch,
    isAllLoaded = props.isAllLoaded,
    setIsAllLoaded = props.setIsAllLoaded,
    isLoadingMore = props.isLoadingMore,
    setIsLoadingMore = props.setIsLoadingMore,
    isLoadMoreButton = props.isLoadMoreButton,
    setIsLoadMoreButton = props.setIsLoadMoreButton,
    handleLoadMore = props.handleLoadMore,
    showTaskModal = props.showTaskModal,
    setShowTaskModal = props.setShowTaskModal,
    statusCheck = props.statusCheck,
    setStatusCheck = props.setStatusCheck,
    projectCheck = props.projectCheck,
    setProjectCheck = props.setProjectCheck,
    projectListData = props.projectListData,
    projectListError = props.projectListError,
    projectListLoading = props.projectListLoading,
    viewType = props.viewType,
    role = props.role,
    userListData = props.userListData,
    userListError = props.userListError,
    userListLoading = props.userListLoading,
    userCheck = props.userCheck,
    setUserCheck = props.setUserCheck;
  var projectList = [{
    label: "All Project",
    value: ""
  }];
  var userList = [{
    label: "All Member",
    value: ""
  }];
  var optionList = [{
    label: "All Tasks",
    value: ""
  }, {
    label: "To Do",
    value: "todo"
  }, {
    label: "In Progress",
    value: "inprogress"
  }, {
    label: "On Hold",
    value: "onhold"
  }, {
    label: "Completed",
    value: "completed"
  }, {
    label: "Due Today",
    value: "due-today"
  }, {
    label: "Past Due Task",
    value: "past-due-task"
  }];
  projectListData === null || projectListData === void 0 ? void 0 : (_projectListData$getT = projectListData.getTaskOverviewProjectsListing) === null || _projectListData$getT === void 0 ? void 0 : _projectListData$getT.map(function (item) {
    var projectName = item.projectName,
      projectId = item.projectId;
    return projectList.push({
      label: projectName,
      value: projectId
    });
  });
  userListData === null || userListData === void 0 ? void 0 : (_userListData$getProj = userListData.getProjectUser) === null || _userListData$getProj === void 0 ? void 0 : _userListData$getProj.map(function (item) {
    var userId = item.userId,
      displayName = item.displayName;
    return userList.push({
      label: displayName,
      value: userId
    });
  });
  var handleShowTaskDetails = function handleShowTaskDetails(list) {
    setShowTaskModal(list);
  };
  var handleCloseTaskDetails = function handleCloseTaskDetails() {
    setShowTaskModal(null);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "task-overview-grid-three"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-overview-grid-task-list-combine"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-overview-grid-over-all-summary-card-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-overview-grid-over-all-summary-card-head-span "
  }, viewType == "myView" ? "Tasks Assigned to Me" : "Tasks Assigned to the Team"), viewType !== "myView" && role !== "Head" && role !== "Member" ? /*#__PURE__*/React.createElement("div", {
    className: "task-overview-my-task-filter-project"
  }, userListLoading ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(Select, {
    value: userCheck,
    onChange: function onChange(e) {
      return setUserCheck(e);
    },
    options: userList,
    className: "task-overview-my-task-user-select"
    //styles={customStyles}
    ,
    classNamePrefix: "Filter By User"
    //isMulti
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: "task-overview-my-task-filter-project"
  }, projectListLoading ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(Select, {
    value: projectCheck,
    onChange: function onChange(e) {
      return setProjectCheck(e);
    },
    options: projectList,
    className: "task-overview-my-task-user-select"
    //styles={customStyles}
    ,
    classNamePrefix: "Filter By User"
    //isMulti
  })), /*#__PURE__*/React.createElement("div", {
    className: "task-overview-my-task-filter-user"
  }, /*#__PURE__*/React.createElement(Select, {
    value: statusCheck,
    onChange: function onChange(e) {
      return setStatusCheck(e);
    },
    options: optionList,
    className: "task-overview-my-task-user-select"
    //styles={customStyles}
    ,
    classNamePrefix: "Filter By User"
    //isMulti
  }))), /*#__PURE__*/React.createElement(MyTaskList, {
    taskOverviewMyTaskDetailsData: taskOverviewMyTaskDetailsData,
    taskOverviewMyTaskDetailsError: taskOverviewMyTaskDetailsError,
    taskOverviewMyTaskDetailsLoading: taskOverviewMyTaskDetailsLoading,
    setTaskOverviewDataFetch: setTaskOverviewDataFetch,
    isAllLoaded: isAllLoaded,
    setIsAllLoaded: setIsAllLoaded,
    isLoadingMore: isLoadingMore,
    setIsLoadingMore: setIsLoadingMore,
    isLoadMoreButton: isLoadMoreButton,
    setIsLoadMoreButton: setIsLoadMoreButton,
    handleLoadMore: handleLoadMore,
    handleShowTaskDetails: handleShowTaskDetails
  })), /*#__PURE__*/React.createElement(TaskDetailsModal, {
    showTaskModal: showTaskModal,
    setShowTaskModal: setShowTaskModal,
    handleShowTaskDetails: handleShowTaskDetails,
    handleCloseTaskDetails: handleCloseTaskDetails
  }));
};
var MyTaskList = function MyTaskList(props) {
  var _taskOverviewMyTaskDe, _taskOverviewMyTaskDe2, _taskOverviewMyTaskDe3, _taskOverviewMyTaskDe4, _taskOverviewMyTaskDe5;
  var taskOverviewMyTaskDetailsData = props.taskOverviewMyTaskDetailsData,
    taskOverviewMyTaskDetailsError = props.taskOverviewMyTaskDetailsError,
    taskOverviewMyTaskDetailsLoading = props.taskOverviewMyTaskDetailsLoading,
    setTaskOverviewDataFetch = props.setTaskOverviewDataFetch,
    isAllLoaded = props.isAllLoaded,
    setIsAllLoaded = props.setIsAllLoaded,
    isLoadingMore = props.isLoadingMore,
    setIsLoadingMore = props.setIsLoadingMore,
    isLoadMoreButton = props.isLoadMoreButton,
    setIsLoadMoreButton = props.setIsLoadMoreButton,
    handleLoadMore = props.handleLoadMore,
    handleShowTaskDetails = props.handleShowTaskDetails;
  if (taskOverviewMyTaskDetailsLoading) {
    return /*#__PURE__*/React.createElement("div", {
      className: "task-overview-grid-task-list-per-employee"
    }, /*#__PURE__*/React.createElement(Loader, null));
  }
  if (taskOverviewMyTaskDetailsError) {
    return /*#__PURE__*/React.createElement("div", null, "Something went wrong, pls refresh the page");
  }
  if (!taskOverviewMyTaskDetailsData) {
    return null;
  }
  setTaskOverviewDataFetch(false);
  if ((taskOverviewMyTaskDetailsData === null || taskOverviewMyTaskDetailsData === void 0 ? void 0 : (_taskOverviewMyTaskDe = taskOverviewMyTaskDetailsData.getTaskOvewviewMyTaskCard) === null || _taskOverviewMyTaskDe === void 0 ? void 0 : _taskOverviewMyTaskDe.length) !== 0 && (taskOverviewMyTaskDetailsData === null || taskOverviewMyTaskDetailsData === void 0 ? void 0 : (_taskOverviewMyTaskDe2 = taskOverviewMyTaskDetailsData.getTaskOvewviewMyTaskCard) === null || _taskOverviewMyTaskDe2 === void 0 ? void 0 : _taskOverviewMyTaskDe2.length) < LIMIT && !isAllLoaded) {
    setIsAllLoaded(true);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "task-overview-grid-task-list-per-employee"
  }, taskOverviewMyTaskDetailsData !== null && taskOverviewMyTaskDetailsData !== void 0 && (_taskOverviewMyTaskDe3 = taskOverviewMyTaskDetailsData.getTaskOvewviewMyTaskCard) !== null && _taskOverviewMyTaskDe3 !== void 0 && _taskOverviewMyTaskDe3.length ? /*#__PURE__*/React.createElement(Table, {
    striped: true,
    borderless: true
  }, /*#__PURE__*/React.createElement("thead", {
    className: "task-overview-grid-task-list-per-employee-header"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Task Name"), /*#__PURE__*/React.createElement("th", null, "Project Name"), /*#__PURE__*/React.createElement("th", null, "Status"), /*#__PURE__*/React.createElement("th", null, "Due Date"), /*#__PURE__*/React.createElement("th", null, "Priority"), /*#__PURE__*/React.createElement("th", null))), /*#__PURE__*/React.createElement("tbody", null, taskOverviewMyTaskDetailsData === null || taskOverviewMyTaskDetailsData === void 0 ? void 0 : (_taskOverviewMyTaskDe4 = taskOverviewMyTaskDetailsData.getTaskOvewviewMyTaskCard) === null || _taskOverviewMyTaskDe4 === void 0 ? void 0 : _taskOverviewMyTaskDe4.map(function (list, index) {
    var taskId = list.taskId,
      taskName = list.taskName,
      dueDate = list.dueDate,
      taskStatus = list.taskStatus,
      projectName = list.projectName,
      priority = list.priority,
      totalWorkedTime = list.totalWorkedTime,
      taskDescription = list.taskDescription,
      dueCrossedCheck = list.dueCrossedCheck;
    return /*#__PURE__*/React.createElement("tr", {
      key: index,
      className: "task-overview-grid-task-list-per-employee-table-content"
    }, /*#__PURE__*/React.createElement("td", {
      className: "task-overview-grid-task-list-per-employee-table-content-task-name"
    }, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, taskName)
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-overview-grid-task-list-per-employee-table-content-task-name"
    }, taskName))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(OverlayTrigger, {
      rootClose: true,
      placement: "top",
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "tooltip-bottom",
        className: "project-tooltip-start"
      }, projectName)
    }, /*#__PURE__*/React.createElement("div", {
      className: "task-overview-grid-task-list-per-employee-table-content-project-name"
    }, projectName))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "".concat(taskStatus == "In Progress" ? "task-overview-my-task-badge-primary" : taskStatus == "To Do" ? "task-overview-my-task-badge-secondary" : taskStatus == "On Hold" ? "task-overview-my-task-badge-hold" : "task-overview-my-task-badge-info")
    }, taskStatus)), /*#__PURE__*/React.createElement("td", {
      className: "".concat(dueDate ? dueCrossedCheck == "crossed" && taskStatus !== "Completed" && taskStatus !== "On Hold" ? "task-overview-task-details-card-value-due-crossed" : "" : "task-tracker-task-details-card-value-none")
    }, dueDate != null ? moment.unix(Number(dueDate) / 1000).format("DD MMM, YYYY") : "-"), /*#__PURE__*/React.createElement("td", {
      className: " ".concat(priority && priority !== "None" ? "" : "task-tracker-task-details-card-value-none")
    }, /*#__PURE__*/React.createElement("span", {
      className: " task-overview-table-description-priority-".concat(priority)
    }, priority ? "".concat(priority.charAt(0).toUpperCase() + priority.slice(1)) : "None")), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
      className: "desktop-home-project-card-task-tracker-table-description-priority-root project-detail-cursor",
      onClick: function onClick(e) {
        return handleShowTaskDetails({
          taskId: taskId,
          taskName: taskName,
          dueDate: dueDate,
          taskStatus: taskStatus,
          projectName: projectName,
          priority: priority,
          taskDescription: taskDescription,
          totalWorkedTime: totalWorkedTime,
          dueCrossedCheck: dueCrossedCheck
        });
      }
    }, /*#__PURE__*/React.createElement(FiMaximize, {
      className: "desktop-home-project-card-task-tracker-table-description-glass-icon"
    }), /*#__PURE__*/React.createElement("span", {
      className: "desktop-home-project-card-task-tracker-table-description-priority "
    }, "View details"), " ")));
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "task-overview-no-data-div"
  }, "No task found."), taskOverviewMyTaskDetailsData !== null && taskOverviewMyTaskDetailsData !== void 0 && (_taskOverviewMyTaskDe5 = taskOverviewMyTaskDetailsData.getTaskOvewviewMyTaskCard) !== null && _taskOverviewMyTaskDe5 !== void 0 && _taskOverviewMyTaskDe5.length ? /*#__PURE__*/React.createElement("div", {
    className: "task-overview-load-more-button"
  }, !isAllLoaded ? /*#__PURE__*/React.createElement(React.Fragment, null, isLoadingMore && !isLoadMoreButton ? /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-load-more-button"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(Button, {
    variant: "outline-primary",
    onClick: function onClick() {
      handleLoadMore();
    }
  }, "Load more")) : /*#__PURE__*/React.createElement("p", {
    className: "screenshot-load-more-button project-management-miled-color"
  }, "You have seen all the tasks")) : null);
};
var TaskDetailsModal = function TaskDetailsModal(props) {
  var showTaskModal = props.showTaskModal,
    handleCloseTaskDetails = props.handleCloseTaskDetails;
  if (showTaskModal == null) {
    return null;
  }
  var taskId = showTaskModal.taskId,
    taskName = showTaskModal.taskName,
    dueDate = showTaskModal.dueDate,
    taskStatus = showTaskModal.taskStatus,
    projectName = showTaskModal.projectName,
    priority = showTaskModal.priority,
    taskDescription = showTaskModal.taskDescription,
    totalWorkedTime = showTaskModal.totalWorkedTime,
    dueCrossedCheck = showTaskModal.dueCrossedCheck;

  //const isDueDateCrossed = moment(dueDate) < moment();

  return /*#__PURE__*/React.createElement(Modal, {
    show: showTaskModal,
    onHide: handleCloseTaskDetails,
    centered: true,
    size: "lg",
    className: "task-tracker-task-detail-modal"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "task-tracker-task-detail-modal-header",
    closeButton: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "task-tracker-task-detail-modal-title"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-tracker-task-detail-modal-title-project-name"
  }, projectName), taskName)), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "task-overview-detail-modal-body "
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-overview-modal-body-div"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "project-details-task-details-card project-details-task-details-card-description-card"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "project-details-task-details-card-title text-dark"
  }, "Task Description"), /*#__PURE__*/React.createElement("h4", {
    "class": "text mb-0 mt-1 font-weight-bold text-dark"
  }, taskDescription)), /*#__PURE__*/React.createElement("div", {
    "class": "project-details-task-details-summary"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "project-details-task-details-card"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "project-details-task-details-card-title text-dark"
  }, "Total Worked Hours"), /*#__PURE__*/React.createElement("h4", {
    "class": "text mb-0 mt-1 font-weight-bold text-dark"
  }, totalWorkedTime)), /*#__PURE__*/React.createElement("div", {
    "class": "project-details-task-details-card"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "project-details-task-details-card-title text-dark"
  }, "Task Due Date"), /*#__PURE__*/React.createElement("h4", {
    className: "text mb-0 mt-1 font-weight-bold text-dark ".concat(dueDate ? dueCrossedCheck == "crossed" && taskStatus !== "Completed" && taskStatus !== "On Hold" ? "task-tracker-task-details-card-value-due-crossed" : "" : "task-tracker-task-details-card-value-none")
  }, dueDate ? dueCrossedCheck && taskStatus !== "Completed" && taskStatus !== "On Hold" ? "".concat(moment.unix(dueDate / 1000).format("DD MMM, YYYY"), " (On Due)") : moment.unix(dueDate / 1000).format("DD MMM, YYYY") : "Not Selected")), /*#__PURE__*/React.createElement("div", {
    "class": "project-details-task-details-card"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "project-details-task-details-card-title text-dark"
  }, "Task Priority"), /*#__PURE__*/React.createElement("h4", {
    className: "text mb-0 mt-1 font-weight-bold text-dark ".concat(priority && priority !== "None" ? "" : "task-tracker-task-details-card-value-none")
  }, priority ? "".concat(priority.charAt(0).toUpperCase() + priority.slice(1)) : "None")), /*#__PURE__*/React.createElement("div", {
    "class": "project-details-task-details-card"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "project-details-task-details-card-title text-dark"
  }, "Task Status"), /*#__PURE__*/React.createElement("h4", {
    "class": "text mb-0 mt-1 font-weight-bold text-dark"
  }, taskStatus))))));
};
var ChartView = function ChartView(props) {
  var _taskOverviewMyTaskCh, _taskOverviewMyTaskCh2, _taskOverviewMyTaskCh3, _taskOverviewMyTaskCh4, _taskOverviewMyTaskCh5, _taskOverviewMyTaskCh6, _taskOverviewMyTaskCh7, _taskOverviewMyTaskCh8, _taskOverviewMyTaskCh9, _taskOverviewMyTaskCh10, _taskOverviewMyTaskCh11, _taskOverviewMyTaskCh12, _taskOverviewMyTaskCh13, _taskOverviewMyTaskCh14;
  var taskOverviewMyTaskChartData = props.taskOverviewMyTaskChartData,
    taskOverviewMyTaskChartError = props.taskOverviewMyTaskChartError,
    taskOverviewMyTaskChartLoading = props.taskOverviewMyTaskChartLoading,
    setTaskOverviewChartFetch = props.setTaskOverviewChartFetch;
  if (taskOverviewMyTaskChartLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (taskOverviewMyTaskChartError) {
    return /*#__PURE__*/React.createElement("div", null, "Something went wrong, pls refresh the page");
  }
  if (!taskOverviewMyTaskChartData) {
    return null;
  }
  setTaskOverviewChartFetch(false);
  var teamTopAppsAndWebsiteChart = taskOverviewMyTaskChartData === null || taskOverviewMyTaskChartData === void 0 ? void 0 : (_taskOverviewMyTaskCh = taskOverviewMyTaskChartData.getTaskOvewviewMyTaskChart) === null || _taskOverviewMyTaskCh === void 0 ? void 0 : _taskOverviewMyTaskCh.reduce(function (acc, curr) {
    var title = curr.title,
      taskCount = curr.taskCount;
    return [].concat(_toConsumableArray(acc), [[title, taskCount, "<div class=\"apps-tootlip\">\n            <span class=\"apps-tootlip-title\">".concat(title, "</span>\n            <br>\n            <span class=\"apps-tootlip apps-tootlip-time\">Task Count: ").concat(taskCount, "</span>\n          </div>")]]);
  }, [["Task", "Task count", {
    role: "tooltip",
    type: "string",
    p: {
      html: true
    }
  }]]);
  return /*#__PURE__*/React.createElement("div", {
    className: "task-overview-website-chart"
  }, taskOverviewMyTaskChartData !== null && taskOverviewMyTaskChartData !== void 0 && (_taskOverviewMyTaskCh2 = taskOverviewMyTaskChartData.getTaskOvewviewMyTaskChart) !== null && _taskOverviewMyTaskCh2 !== void 0 && _taskOverviewMyTaskCh2.length ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Chart, {
    width: "100%",
    height: "250px",
    position: "absolute",
    chartType: "PieChart",
    loader: /*#__PURE__*/React.createElement("div", null, "Loading Chart"),
    data: teamTopAppsAndWebsiteChart,
    options: {
      legend: {
        position: "bottom",
        textStyle: {
          fontSize: "100px"
        }
      },
      pieSliceText: "none",
      chartArea: {
        width: "95%",
        height: "90%"
      },
      slices: {
        0: {
          color: "#84a5e5"
        },
        1: {
          color: "#81d1ac"
        },
        2: {
          color: "#e7bf78"
        },
        3: {
          color: "#e7ad9e"
        }
        // 0: { color: "#218380" },
        // 1: { color: "#D4AFB9" },
        // 2: { color: "#7D84B2" },
        // 3: { color: "#DBF4A7" },
      },
      pieHole: 0.4,
      tooltip: {
        isHtml: true,
        trigger: "visible"
      }
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "task-overview-website-chart-text-div-whole"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-overview-website-chart-text-div-splits"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-overview-website-chart-text-divs mr-2 task-overview-website-chart-width"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("task-overview-website-chart-text-div", {
      "task-overview-website-chart-text-div-to-do": (taskOverviewMyTaskChartData === null || taskOverviewMyTaskChartData === void 0 ? void 0 : (_taskOverviewMyTaskCh3 = taskOverviewMyTaskChartData.getTaskOvewviewMyTaskChart[1]) === null || _taskOverviewMyTaskCh3 === void 0 ? void 0 : _taskOverviewMyTaskCh3.title) == "To Do"
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: "task-overview-website-chart-text-div-letter"
  }, taskOverviewMyTaskChartData === null || taskOverviewMyTaskChartData === void 0 ? void 0 : (_taskOverviewMyTaskCh4 = taskOverviewMyTaskChartData.getTaskOvewviewMyTaskChart[1]) === null || _taskOverviewMyTaskCh4 === void 0 ? void 0 : _taskOverviewMyTaskCh4.title, " -", " ", /*#__PURE__*/React.createElement("span", null, taskOverviewMyTaskChartData === null || taskOverviewMyTaskChartData === void 0 ? void 0 : (_taskOverviewMyTaskCh5 = taskOverviewMyTaskChartData.getTaskOvewviewMyTaskChart[1]) === null || _taskOverviewMyTaskCh5 === void 0 ? void 0 : _taskOverviewMyTaskCh5.taskCount))), /*#__PURE__*/React.createElement("div", {
    className: "task-overview-website-chart-text-divs "
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("task-overview-website-chart-text-div", {
      "task-overview-website-chart-text-div-progress": (taskOverviewMyTaskChartData === null || taskOverviewMyTaskChartData === void 0 ? void 0 : (_taskOverviewMyTaskCh6 = taskOverviewMyTaskChartData.getTaskOvewviewMyTaskChart[0]) === null || _taskOverviewMyTaskCh6 === void 0 ? void 0 : _taskOverviewMyTaskCh6.title) == "In Progress"
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: "task-overview-website-chart-text-div-letter"
  }, taskOverviewMyTaskChartData === null || taskOverviewMyTaskChartData === void 0 ? void 0 : (_taskOverviewMyTaskCh7 = taskOverviewMyTaskChartData.getTaskOvewviewMyTaskChart[0]) === null || _taskOverviewMyTaskCh7 === void 0 ? void 0 : _taskOverviewMyTaskCh7.title, " -", " ", /*#__PURE__*/React.createElement("span", null, taskOverviewMyTaskChartData === null || taskOverviewMyTaskChartData === void 0 ? void 0 : (_taskOverviewMyTaskCh8 = taskOverviewMyTaskChartData.getTaskOvewviewMyTaskChart[0]) === null || _taskOverviewMyTaskCh8 === void 0 ? void 0 : _taskOverviewMyTaskCh8.taskCount)))), /*#__PURE__*/React.createElement("div", {
    className: "task-overview-website-chart-text-div-splits"
  }, /*#__PURE__*/React.createElement("div", {
    className: "task-overview-website-chart-text-divs mr-2 task-overview-website-chart-width"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("task-overview-website-chart-text-div", {
      "task-overview-website-chart-text-div-hold": (taskOverviewMyTaskChartData === null || taskOverviewMyTaskChartData === void 0 ? void 0 : (_taskOverviewMyTaskCh9 = taskOverviewMyTaskChartData.getTaskOvewviewMyTaskChart[3]) === null || _taskOverviewMyTaskCh9 === void 0 ? void 0 : _taskOverviewMyTaskCh9.title) == "On Hold"
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: "task-overview-website-chart-text-div-letter"
  }, taskOverviewMyTaskChartData === null || taskOverviewMyTaskChartData === void 0 ? void 0 : (_taskOverviewMyTaskCh10 = taskOverviewMyTaskChartData.getTaskOvewviewMyTaskChart[3]) === null || _taskOverviewMyTaskCh10 === void 0 ? void 0 : _taskOverviewMyTaskCh10.title, " -", " ", /*#__PURE__*/React.createElement("span", null, taskOverviewMyTaskChartData === null || taskOverviewMyTaskChartData === void 0 ? void 0 : (_taskOverviewMyTaskCh11 = taskOverviewMyTaskChartData.getTaskOvewviewMyTaskChart[3]) === null || _taskOverviewMyTaskCh11 === void 0 ? void 0 : _taskOverviewMyTaskCh11.taskCount))), /*#__PURE__*/React.createElement("div", {
    className: "task-overview-website-chart-text-divs "
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("task-overview-website-chart-text-div", {
      "task-overview-website-chart-text-div-completed": (taskOverviewMyTaskChartData === null || taskOverviewMyTaskChartData === void 0 ? void 0 : (_taskOverviewMyTaskCh12 = taskOverviewMyTaskChartData.getTaskOvewviewMyTaskChart[2]) === null || _taskOverviewMyTaskCh12 === void 0 ? void 0 : _taskOverviewMyTaskCh12.title) == "Completed"
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: "task-overview-website-chart-text-div-letter"
  }, taskOverviewMyTaskChartData === null || taskOverviewMyTaskChartData === void 0 ? void 0 : (_taskOverviewMyTaskCh13 = taskOverviewMyTaskChartData.getTaskOvewviewMyTaskChart[2]) === null || _taskOverviewMyTaskCh13 === void 0 ? void 0 : _taskOverviewMyTaskCh13.title, " -", " ", /*#__PURE__*/React.createElement("span", null, taskOverviewMyTaskChartData === null || taskOverviewMyTaskChartData === void 0 ? void 0 : (_taskOverviewMyTaskCh14 = taskOverviewMyTaskChartData.getTaskOvewviewMyTaskChart[2]) === null || _taskOverviewMyTaskCh14 === void 0 ? void 0 : _taskOverviewMyTaskCh14.taskCount)))))) : /*#__PURE__*/React.createElement("div", {
    className: "task-overview-no-data-div"
  }, "No task found"));
};
export default TaskOverview;